import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import randomstring from 'uuid/v4';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/user.actions';
import * as actionsHome from '../../../../actions/process.home.actions';

import Grid from '@material-ui/core/Grid';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import BlueButton from '../../../buttons/BlueButton';
import Client from './Client';

const pagination = 15;

function sortData(arr, search, all_employees) {
    if (!arr) {
        return arr;
    } else {
        const result = []
            .concat(arr)
            .sort((a, b) =>
                a.nombre.toUpperCase().trim() < b.nombre.toUpperCase().trim() ? -1 : 1,
            )
            .reduce((arr, info) => {
                if (search && search.length > 0) {
                    const filter = search.filter(
                        (s) => info.nombre && info.nombre.toUpperCase().includes(s),
                    );
                    if (filter && filter.length > 0 && (all_employees || info.activo)) {
                        arr.push(<Client key={randomstring()} client={info} />);
                    }
                } else if (all_employees || info.activo) {
                    arr.push(<Client key={randomstring()} client={info} />);
                }
                return arr;
            }, []);
        return result;
    }
}

class ListEmployees extends React.Component {
    state = {
        index: 0,
        clients: sortData(this.props.clients, this.props.search, this.props.all_employees),
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            index: 0,
            clients: sortData(nextProps.clients, nextProps.search, nextProps.all_employees),
        });
    }

    handleClick = (event) => {
        this.setState({ index: this.state.index + pagination });
    };


    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { index, clients } = this.state;
        const { clients_is_loading, clients_has_errored } = this.props;
        const data = [...clients].splice(0, index + pagination);
        const length = clients.length;

        if (clients_has_errored.hasErrored) {
            return <Error open type={clients_has_errored.hasErrored} message={clients_has_errored.error} handleClose={this.handleBack} />;
        } else if (clients === undefined) {
            return (
                <Error
                    open
                    message={<FormattedMessage id="error_clients_not_found" />}
                    handleClose={this.handleBack}
                />
            );
        } else {
            return (
                <div className={'flex_full_column padding_bottom_9 padding_top_12 height100'}>
                    {clients_is_loading && <Loading open opacity />}
                    <div className="flex_full overflow_y_scroll" onScroll={this.handleScroll}>
                        {data.map((u) => {
                            return u;
                        })}
                        {length > index + pagination && (
                            <Grid
                                container
                                justify="center"
                                className={'flex_grow_1 align_center margin_top_24'}
                            >
                                <Grid item xs={10} sm={6} className="padding_bottom_12">
                                    <BlueButton id="next" onClick={this.handleClick} />
                                </Grid>
                            </Grid>
                        )}
                    </div>
                </div>
            );
        }
    }
}

ListEmployees.propTypes = {
    clients: PropTypes.array.isRequired,
    clients_is_loading: PropTypes.bool.isRequired,
    clients_has_errored: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        clients: state.clients,
        clients_is_loading: state.clients_is_loading,
        clients_has_errored: state.clients_has_errored,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionsHome), dispatch);
};

ListEmployees = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ListEmployees);

export default withRouter(ListEmployees);



// WEBPACK FOOTER //
// ./src/components/complex/manage/customers/List.js